module.exports = __webpack_public_path__ + "img/banner_left.dcfc503e.png";